Vendd.Scripts.load(function () {

    var $wrappers = $('.x-project-agora-banner');

    if ($wrappers.length < 1)
        return;

    $wrappers.each(function () {
        var $wrapper = $(this);
        var wrapper = $wrapper.get(0);

        var trackingId = undefined; // Set upon successful banner initialization.

        wrapper.init = function () {
            var $component = $('.project-agora-banner', $wrapper);
            var data = $component.data();

            trackingId = $('.js-banner', $wrapper).data('project-agora-id');

            if (trackingId) {
                Vendd.MessageBus.publish(wrapper, new Vendd.ProjectAgora.Messages.TrackBannerImpression(trackingId));
            }
            else if (data.asyncLoad) {
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProjectAgora.Messages.GetBanner(
                    data.widgetId,
                    data.filterSearchTerm,
                    data.filterCategoryPathComponents
                ));
            }
        };

        wrapper.onGetBannerSuccess = function (response) {
            if (trackingId) {
                return; // Prevent updates on already successfully initialized banners.
            }

            var $component = $('.project-agora-banner', $wrapper);
            var data = $component.data();

            var model = response.message.data.model;

            if (data.widgetId === model.WidgetId) {
                var html = Vendd.Handlebars.parse("projectAgoraBanner_A", model);
                $wrapper.empty().append(html);
                wrapper.init();
            }
        }

        wrapper.onGetBannerFailure = function (response) {
            // Nothing to be done.
        }

        Vendd.MessageBus.subscribe(Vendd.ProjectAgora.Messages.GetBannerSuccess, wrapper, wrapper.onGetBannerSuccess);
        Vendd.MessageBus.subscribe(Vendd.ProjectAgora.Messages.GetBannerFailure, wrapper, wrapper.onGetBannerFailure);

        wrapper.init();
    });
});
